<template>
  <VTransitionCollapse lazy style="width: 100%" :visible="files.length > 0">
    <div v-if="files.length > 0" class="v-upload__list" @click.stop>
      <slot name="file-list">
        <div v-for="(file, index) in files" :key="index" class="v-upload__list-item">
          <div class="flex-center">
            <VIcon :icon="icon(file)" type="primary" />
            <slot :file :index name="file-name">
              <span v-text="file.name" />
            </slot>
          </div>
          <div class="flex-center">
            <template v-if="file.size">{{ humanSize(file.size) }}</template>
            <VLoadingDots v-if="file.loading" :size="5" style="margin-left: 10px" />
            <VButton
              v-else
              :key="`${index}.${file.name}`"
              hover-type="secondary"
              icon="Delete"
              rounded
              size="mini"
              style="margin-left: 5px"
              type="link"
              @click.stop="emit('removeFile', index)"
            />
          </div>
        </div>
      </slot>
    </div>
  </VTransitionCollapse>
</template>

<script setup lang="ts">
import { type FileLike, type VIconIcon } from '../../types.ts'
import { humanSize } from '../../utils/helpers.ts'
import VIcon from '../Icon/VIcon.vue'
import VButton from '../VButton.vue'
import VLoadingDots from '../VLoadingDots.vue'
import VTransitionCollapse from '../VTransitionCollapse.vue'

interface Props {
  files: FileLike[]
}

defineProps<Props>()

const emit = defineEmits<{
  removeFile: [index: number]
}>()

defineSlots<{
  'file-list'(): any
  'file-name'(props: { file: FileLike; index: number }): any
}>()

const extensionsToIcons: Record<string, VIconIcon> = {
  csv: 'Calendar',
  jpeg: 'Photo',
  jpg: 'Photo',
  pdf: 'Document',
  png: 'Photo',
  svg: 'Photo',
  webp: 'Photo',
  xsl: 'Calendar',
  xslx: 'Calendar',
  zip: 'Archive',
} as const

function icon(file: FileLike) {
  return extensionsToIcons[file.name.split('.').pop() as string] ?? 'Document'
}

defineExpose({
  icon,
})
</script>

<style>
.v-upload__list {
  margin: 20px 0;
  word-break: break-all;
}

.v-upload__list-item {
  font-size: 14px;
  margin: 3px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .v-icon:not(.v-icon-delete) {
    margin-right: 5px;
  }
}
</style>
